import { useTranslate } from '@tolgee/react';

import { Icon } from '../Icon';

type NonCompliantBannerProps = {
  label?: string;
};

export function NonCompliantBanner({ label }: NonCompliantBannerProps) {
  const { t } = useTranslate();
  return (
    <div className="mt-4 flex w-full items-center justify-center gap-4 rounded border border-[#72080A] bg-[#FFF5CE] px-4 py-3 text-center text-[#72080A]">
      <Icon icon="alert" isCustom />
      {label || t('common.ticket_non_compliant_banner')}
    </div>
  );
}
